import { StyleSheet, Platform } from 'react-native';
import { FontFamily } from '../../constants/fonts';
import { AdminColors } from '../Admin/constants/adminColors';

export const styles = StyleSheet.create({
  root: { flex: 1, backgroundColor: AdminColors.bgPage },
  scrollContent: { padding: 24, paddingBottom: 80, gap: 20 },

  // ── Breadcrumb ────────────────────────────────────────────────────────────
  breadcrumb: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 2, marginBottom: 4 },
  bcLink: { fontSize: 14, color: AdminColors.blue700, fontFamily: FontFamily.regular },
  bcSep: { fontSize: 14, color: '#BDBDBD', marginHorizontal: 2 },
  bcCurrent: { fontSize: 14, color: '#1A1A1A', fontWeight: '500', fontFamily: FontFamily.medium },

  pageTitle: { fontSize: 28, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold },

  // ── Info box (read-only order info) ──────────────────────────────────────
  infoBox: {
    backgroundColor: AdminColors.blue25,
    borderWidth: 1,
    borderColor: AdminColors.blue75,
    borderRadius: 8,
    padding: 20,
    position: 'relative',
  },
  roLabel: {
    position: 'absolute', top: 10, right: 12,
    backgroundColor: AdminColors.blue75, borderRadius: 4,
    paddingHorizontal: 7, paddingVertical: 2,
  },
  roText: {
    fontSize: 10, fontWeight: '700', letterSpacing: 0.6,
    color: AdminColors.blue800, textTransform: 'uppercase', fontFamily: FontFamily.bold,
  },
  infoGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 16, marginTop: 4 },
  infoField: { flexDirection: 'column', gap: 2, minWidth: 120 },
  infoKey: {
    fontSize: 11, fontWeight: '700', textTransform: 'uppercase',
    letterSpacing: 0.5, color: AdminColors.gray450, fontFamily: FontFamily.bold,
  },
  infoVal: { fontSize: 15, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium },
  mono: { letterSpacing: 0.4, fontSize: 14 },

  // ── Card ──────────────────────────────────────────────────────────────────
  card: {
    backgroundColor: '#fff', borderRadius: 8, padding: 24,
    ...Platform.select({
      ios: { shadowColor: '#000', shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.06, shadowRadius: 4 },
      android: { elevation: 1 },
    }),
  },
  cardTitle: { fontSize: 18, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold, marginBottom: 4 },
  cardSub: { fontSize: 13, color: AdminColors.gray450, fontFamily: FontFamily.regular, marginBottom: 16 },

  // ── Reason code grid ──────────────────────────────────────────────────────
  rcGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 12 },
  rcTile: {
    position: 'relative', backgroundColor: '#fff',
    borderWidth: 1.5, borderColor: AdminColors.gray50,
    borderRadius: 10, paddingVertical: 18, paddingHorizontal: 18,
    minHeight: 138,
    flexDirection: 'column', gap: 10,
  },
  rcTileSel: {
    borderWidth: 2, borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue25, paddingVertical: 17, paddingHorizontal: 17,
  },
  rcCheck: {
    position: 'absolute', top: 8, right: 8,
    width: 20, height: 20, borderRadius: 10,
    backgroundColor: AdminColors.blue700,
    alignItems: 'center', justifyContent: 'center',
  },
  rcReasonRow: { flexDirection: 'row', alignItems: 'center', gap: 8, paddingRight: 18 },
  rcReasonIconWrap: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rcEmojiIcon: { fontSize: 17, lineHeight: 20 },
  rcAbbrTag: { borderRadius: 100, paddingHorizontal: 8, paddingVertical: 2, alignSelf: 'flex-start' },
  rcAbbrText: { fontSize: 11, fontWeight: '700', letterSpacing: 0.8, fontFamily: FontFamily.bold },
  rcLabel: { fontSize: 13, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium, lineHeight: 18 },

  // abbr tag color variants
  abbrRed: { backgroundColor: AdminColors.red75 },
  abbrRedText: { color: '#AB2B09' },
  abbrOrange: { backgroundColor: '#F9E0CA' },
  abbrOrangeText: { color: '#4D2E0C' },
  abbrBlue: { backgroundColor: AdminColors.blue75 },
  abbrBlueText: { color: AdminColors.blue900 },
  abbrPurple: { backgroundColor: '#E1E3FD' },
  abbrPurpleText: { color: '#31217D' },
  abbrTeal: { backgroundColor: '#AAD2E2' },
  abbrTealText: { color: '#1E5A7A' },
  abbrGray: { backgroundColor: AdminColors.gray50 },
  abbrGrayText: { color: AdminColors.gray600 },

  // ── Reschedule radio options ───────────────────────────────────────────────
  radioRow: { flexDirection: 'row', gap: 14, flexWrap: 'wrap' },
  radioOpt: {
    flexDirection: 'row', alignItems: 'center', gap: 10,
    borderWidth: 1.5, borderColor: AdminColors.gray50,
    borderRadius: 8, paddingVertical: 12, paddingHorizontal: 18,
    backgroundColor: '#fff', minWidth: 170,
  },
  radioOptSel: {
    borderWidth: 2, borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue25,
    paddingVertical: 11, paddingHorizontal: 17,
  },
  radioDot: {
    width: 18, height: 18, borderRadius: 9,
    borderWidth: 1.5, borderColor: AdminColors.gray300,
    backgroundColor: '#fff', alignItems: 'center', justifyContent: 'center',
  },
  radioDotSel: { borderColor: AdminColors.blue700 },
  radioDotInner: {
    width: 10, height: 10, borderRadius: 5,
    backgroundColor: AdminColors.blue700,
  },
  radioLabel: { fontSize: 14, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium },

  // ── Additional Details text input ─────────────────────────────────────────
  requiredAsterisk: { color: AdminColors.red500, fontWeight: '700' },
  additionalDetailsInput: {
    borderWidth: 1.5,
    borderColor: AdminColors.gray300,
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: '#1A1A1A',
    fontFamily: FontFamily.regular,
    minHeight: 80,
    backgroundColor: '#fff',
  },
  additionalDetailsInputEmpty: {
    borderColor: AdminColors.red500,
  },

  // ── Error messages ────────────────────────────────────────────────────────
  errorText: { fontSize: 12, color: AdminColors.red500, fontWeight: '500', fontFamily: FontFamily.medium, marginTop: 8 },

  // ── Banner errors (unavailable order info, submission failed, etc.) ───────
  errorBanner: {
    flexDirection: 'row', alignItems: 'center', gap: 10,
    backgroundColor: AdminColors.red75, borderWidth: 1, borderColor: AdminColors.red500,
    borderRadius: 8, padding: 14, margin: 24, flexWrap: 'wrap',
  },
  errorBannerText: { flex: 1, fontSize: 14, color: AdminColors.red700, fontFamily: FontFamily.regular },
  returnLink: { fontSize: 14, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },

  // ── Network/retry banner ──────────────────────────────────────────────────
  warnBanner: {
    flexDirection: 'row', alignItems: 'flex-start', gap: 10,
    backgroundColor: AdminColors.yellow50, borderWidth: 1, borderColor: AdminColors.yellow200,
    borderRadius: 8, padding: 12, marginBottom: 4,
  },
  warnBannerText: { flex: 1, fontSize: 14, lineHeight: 20, color: '#6b4a05', fontFamily: FontFamily.regular },

  // ── Form actions ──────────────────────────────────────────────────────────
  formActions: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingTop: 4 },
  cancelBtn: {
    height: 40, paddingHorizontal: 24, borderRadius: 24,
    borderWidth: 1, borderColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  cancelBtnText: { fontSize: 16, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },
  submitBtn: {
    height: 40, paddingHorizontal: 24, borderRadius: 24,
    backgroundColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  submitBtnDisabled: { backgroundColor: AdminColors.gray50 },
  submitBtnText: { fontSize: 16, fontWeight: '700', color: '#fff', fontFamily: FontFamily.bold },
  submitBtnTextDisabled: { color: AdminColors.gray300 },

  // ── Modal overlay ─────────────────────────────────────────────────────────
  overlay: {
    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center', justifyContent: 'center',
    zIndex: 500, padding: 20,
  },
  modal: {
    backgroundColor: '#fff', borderRadius: 8, width: '100%', maxWidth: 430,
    overflow: 'hidden',
    ...Platform.select({
      ios: { shadowColor: '#005EBC', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.12, shadowRadius: 24 },
      android: { elevation: 8 },
    }),
  },
  modalHeader: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
    padding: 16, paddingHorizontal: 24, borderBottomWidth: 1, borderBottomColor: AdminColors.gray25,
  },
  modalTitle: { fontSize: 18, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold },
  modalCloseBtn: { width: 30, height: 30, borderRadius: 6, alignItems: 'center', justifyContent: 'center' },
  modalBody: { padding: 24, gap: 14 },
  modalWarnBanner: {
    flexDirection: 'row', alignItems: 'flex-start', gap: 10,
    backgroundColor: AdminColors.yellow50, borderWidth: 1, borderColor: AdminColors.yellow200,
    borderRadius: 8, padding: 12,
  },
  modalWarnText: { flex: 1, fontSize: 14, lineHeight: 20, color: '#6b4a05', fontFamily: FontFamily.regular },
  modalFineText: { fontSize: 12, color: AdminColors.gray350, fontFamily: FontFamily.regular, lineHeight: 18 },
  modalFooter: {
    flexDirection: 'row', justifyContent: 'flex-end', gap: 16,
    padding: 16, paddingHorizontal: 24, borderTopWidth: 1, borderTopColor: AdminColors.gray25,
  },

  // ── Modal (cancel confirmation) ───────────────────────────────────────────
  modalOverlay: {
    flex: 1, backgroundColor: 'rgba(0,0,0,0.50)',
    alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  modalCard: {
    backgroundColor: '#fff', borderRadius: 12, padding: 28,
    width: '100%', maxWidth: 400, alignItems: 'center', gap: 12,
    ...Platform.select({
      ios: { shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.18, shadowRadius: 16 },
      android: { elevation: 8 },
    }),
  },
  modalCardTitle: { fontSize: 20, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold, textAlign: 'center' },
  modalCardBody: { fontSize: 15, color: AdminColors.gray450, fontFamily: FontFamily.regular, textAlign: 'center', lineHeight: 22 },
  modalBtn: {
    height: 42, paddingHorizontal: 32, borderRadius: 24,
    backgroundColor: AdminColors.blue800, alignItems: 'center', justifyContent: 'center',
  },
  modalBtnText: { fontSize: 15, fontWeight: '700', color: '#fff', fontFamily: FontFamily.bold },
  modalActions: { flexDirection: 'row', gap: 12, marginTop: 8, justifyContent: 'center', alignItems: 'center' },
  modalSecondaryBtn: {
    height: 42, paddingHorizontal: 28, borderRadius: 24,
    borderWidth: 1, borderColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  modalSecondaryBtnText: { fontSize: 15, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },

  // ── Toast ─────────────────────────────────────────────────────────────────
  toastWrap: {
    position: 'absolute', top: 16, left: 20, right: 20,
    alignItems: 'center', zIndex: 700,
  },
  toast: {
    flexDirection: 'row', alignItems: 'center', gap: 12,
    paddingVertical: 12, paddingHorizontal: 18,
    backgroundColor: '#fff', borderRadius: 8,
    borderLeftWidth: 4, borderLeftColor: AdminColors.green600,
    ...Platform.select({
      ios: { shadowColor: '#005EBC', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.12, shadowRadius: 24 },
      android: { elevation: 6 },
    }),
    minWidth: 260,
  },
  toastText: { fontSize: 14, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium, flex: 1 },

  // ── Pallet Type Section ────────────────────────────────────────────────────
  palletTypeOptions: {
    flexDirection: 'row',
    gap: 16,
    marginTop: 12,
    flexWrap: 'wrap',
  },
  palletTypeMultiBanner: {
    backgroundColor: '#FFE5E5',
    borderLeftWidth: 4,
    borderLeftColor: AdminColors.red500,
    padding: 12,
    borderRadius: 4,
    marginTop: 12,
  },
  palletTypeMultiBannerText: {
    fontSize: 14,
    color: AdminColors.red500,
    fontWeight: '500',
    fontFamily: FontFamily.regular,
  },
  palletTypeMultiBannerSubtext: {
    fontSize: 13,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
    marginTop: 8,
  },
  palletOverrideContainer: {
    marginTop: 16,
  },
  palletOverrideInput: {
    borderWidth: 1,
    borderColor: '#D0D0D0',
    borderRadius: 4,
    paddingVertical: 10,
    paddingHorizontal: 12,
    fontSize: 14,
    fontFamily: FontFamily.regular,
    color: '#1A1A1A',
    backgroundColor: '#fff',
  },
  palletOverrideInputError: {
    borderColor: AdminColors.red500,
    backgroundColor: '#FFF5F5',
  },
  palletOverrideErrorText: {
    marginTop: 6,
    marginLeft: 0,
  },
});
